
import { defineComponent, onBeforeMount, reactive } from 'vue'

// components
import PageTitle from '@/common/components/UI/PageTitle/index.vue'
import FailedFetch from '@/common/components/UI/FailedFetch/index.vue'
import TableScrollWrapper from '@/common/components/UI/TableScrollWrapper/index.vue'
import TheTable from '@/common/components/UI/TheTable/index.vue'

// module components
import CommentsFilters from '@/modules/CommentsModule/components/CommentsFilters/index.vue'

// @types
import { Comment, GetCommentsParams } from '@/new-services/types/comments'

// classes
import { DataState } from '@/core/classes/DataState.class'

// constants
import { CommentsColumns } from '@/core/constants/columns/Comments.columns'

// @new-services
import commentsAPI from '@/new-services/comments.service'

export default defineComponent({
    components: {
        PageTitle,
        FailedFetch,
        CommentsFilters,
        TheTable,
        TableScrollWrapper,
    },
    setup() {
        const state = reactive(new DataState<Comment>({}))

        const filters_state = reactive({
            limit: 50,
            //
            number: null as string | null,
            createdAtFrom: null as string | null,
            createdAtTo: null as string | null,
            createdBy: null as number | null,
        })

        const loadComments = async (page: number) => {
            state.pagination.current_page = page

            const params = {
                page,
                ...filters_state,
            }

            try {
                state.is_loading = true
                const data = await commentsAPI.getList(params)

                state.list = data.data.data

                state.pagination.total_pages = data.data.meta.last_page
                state.pagination.total_items = data.data.meta.total

                state.is_failed = false
                state.failure.error_state.is_cancel = false
            } catch (error) {
                state.failure.catchError(error)

                if (state.failure.error_state.is_cancel) {
                    state.is_failed = true
                }
            } finally {
                if (!state.failure.error_state.is_cancel) {
                    state.is_loading = false
                }
            }
        }

        //

        const applyFilters = (params: GetCommentsParams) => {
            filters_state.number = params.number || null
            filters_state.createdAtFrom = params.createdAtFrom || null
            filters_state.createdAtTo = params.createdAtTo || null
            filters_state.createdBy = params.createdBy || null

            loadComments(state.pagination.current_page)
        }

        const resetFilters = () => {
            filters_state.number = null
            filters_state.createdAtFrom = null
            filters_state.createdAtTo = null
            filters_state.createdBy = null

            loadComments(state.pagination.current_page)
        }

        const onLimitChange = (limit: number) => {
            filters_state.limit = limit
            loadComments(state.pagination.current_page)
        }

        //

        onBeforeMount(() => loadComments(1))

        //

        return {
            state,
            filters_state,
            //
            onLimitChange,
            applyFilters,
            resetFilters,
            loadComments,
            //
            CommentsColumns,
        }
    },
})
